import * as React from 'react';
import { MakeListElementContentRamp } from './utils';

export function DefaultListInputListElementContent() {
  return <MakeListElementContentRamp />;
}
